import { render, staticRenderFns } from "./UISearchSymbol.vue?vue&type=template&id=13894df4"
import script from "./UISearchSymbol.vue?vue&type=script&lang=js"
export * from "./UISearchSymbol.vue?vue&type=script&lang=js"
import style0 from "./UISearchSymbol.vue?vue&type=style&index=0&id=13894df4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports